import { Component, computed, inject, input, Input, OnInit } from '@angular/core';
import { ClientCullDTO, CullDTO, PlayerCullDTO, TimeCullDTO } from '../../services/api/api';
import { ModalService } from '../../services/gui/modal/modal.service';
import { FilterDetailsComponent } from '../../pages/datasets/filter-details/filter-details.component';
import { UtilService } from '../../services/util.service';
import { PermissionService } from '../../services/permission.service';

type Filtertype = 'player' | 'geo' | 'time' | 'stateSpace' | 'client';

export class FilterElement {
  filterIcon: string;
  caption: string;
  active: boolean;
  cull: CullDTO;
  type: string;
}

@Component({
  selector: 'sb-comp-filter-overview',
  templateUrl: './filter-overview.component.html',
  styleUrls: ['./filter-overview.component.scss'],
  standalone: false,
})
export class FilterOverviewComponent implements OnInit {
  filterElements: FilterElement[] = [];
  activeElements: number;
  @Input() displayedElements: Filtertype[] = ['time', 'player', 'geo'];
  @Input() maxSize: boolean = false;
  @Input() showCaption: boolean = true;
  @Input() bookingEditorView: boolean = false;

  constructor(
    private modalService: ModalService,
    public util: UtilService,
    public permissionService: PermissionService
  ) {}

  timeCull = input<TimeCullDTO | null>(null);
  playerCull = input<PlayerCullDTO | null>(null);
  geoCull = input<CullDTO | null>(null);
  stateSpaceCull = input<CullDTO | null>(null);
  clientCull = input<ClientCullDTO | null>(null);

  recalculateFilterElements() {
    const filterElements: FilterElement[] = [];
    for (const type of this.displayedElements) {
      const element: FilterElement = new FilterElement();
      switch (type) {
        case 'time':
          element.filterIcon = 'calendar';
          element.caption = 'Time';
          element.cull = this.timeCull();
          element.type = 'TimeCull';
          break;
        case 'stateSpace':
          element.filterIcon = 'users';
          element.caption = 'Targeting';
          element.cull = this.stateSpaceCull();
          element.type = 'StateSpaceCull';
          break;
        case 'geo':
          element.filterIcon = 'globe';
          element.caption = 'Geo';
          element.cull = this.geoCull();
          element.type = 'GeoCull';
          break;
        case 'player':
          element.filterIcon = 'playerOnline';
          element.caption = 'Player';
          element.cull = this.playerCull();
          element.type = 'PlayerCull';
          break;
        case 'client':
          element.filterIcon = 'companyClient';
          element.caption = 'Client';
          element.cull = this.clientCull();
          element.type = 'ClientCull';
          break;
      }
      if (!element.cull) {
        element.active = false;
      } else {
        element.active = true;
        // element.caption = element.cull.name;
      }
      filterElements.push(element);
    }

    this.filterElements = filterElements;
    this.calculateActiveElements();
  }

  calculateActiveElements() {
    this.activeElements = this.filterElements.reduce((count, e) => count + (e.active ? 1 : 0), 0);
  }

  ngOnInit(): void {
    this.recalculateFilterElements();
  }

  openPreviewModal(element: FilterElement) {
    this.modalService
      .showNavigationModal({
        entryComponent: { value: FilterDetailsComponent, data: { cullId: element.cull.id } },
        title: null,
        modalOptions: { windowClass: 'bigXL' },
      })
      .then(() => {})
      .catch(() => {});
  }
}
